import React from 'react';

/**
 * ProjectTypesSection - Project Types We Pursue
 * Three-column feature boxes describing DataFlex project focus areas
 */
function ProjectTypesSection() {
  return (
    <section id="project-types">
      <div className="container">
        {/* Heading */}
        <div className="row wow fadeIn">
          <div className="col-md-12 text-center">
            <div className="title d-inline-block">
              <h6 className="third-color mb-3">Our Focus</h6>
              <h2 className="gradient-text1 mb-3">Project Types We Pursue</h2>
              <p>DataFlex specializes in high-value infrastructure projects that serve public interest while delivering measurable grid benefits. We match strategic partners with opportunity.</p>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="row mt-lg-5">
          <div className="col-md-4 wow fadeInLeft">
            <div className="feature-box">
              <span className="item-number gradient-text1">
                01.
              </span>
              <h6 className="mb-4">Behind-The-Meter Datacenter Compute</h6>
              <p>Large-scale compute facilities deployed as curtailable grid assets, transforming datacenter demand into dispatchable capacity that utilities can control for reliability planning and revenue generation.</p>
            </div>
          </div>
          <div className="col-md-4 wow fadeInUp">
            <div className="feature-box">
              <span className="item-number gradient-text1">
                02.
              </span>
              <h6 className="mb-4">Utility Generation Optimization</h6>
              <p>Strategic deployments that monetize surplus generation capacity, reduce plant cycling wear, and convert reserve margins into steady income streams without new buildout requirements.</p>
            </div>
          </div>
          <div className="col-md-4 wow fadeInRight">
            <div className="feature-box">
              <span className="item-number gradient-text1">
                03.
              </span>
              <h6 className="mb-4">Public-Private Grid Partnerships</h6>
              <p>Structured arrangements between community utilities and datacenter operators, creating deployment pathways with defined terms, operational frameworks, and ownership transitions.</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default ProjectTypesSection;
